<template>
  <div v-if="craftSupplier" class="flex gap-2">
    <img
      width="100px"
      class="flex-none object-cover"
      :src="craftSupplier.supplier_thumbnail"
      :alt="craftSupplier.title"
    />

    <div>
      <h4>{{ craftSupplier.title }}</h4>
      <div
        class="mt-2 flex items-end"
        v-if="
          odysseySupplier &&
          odysseySupplier.rating &&
          odysseySupplier.rating.aggregated_rating
        "
      >
        <rating
          :value="odysseySupplier.rating.aggregated_rating.supplier_rating"
          class="mr-1"
          size="28"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Rating from "../../core/Rating";
import axios from "axios";

export default {
  components: {
    Rating,
  },
  props: ["supplierId"],
  data() {
    return {
      craftSupplier: null,
      odysseySupplier: null,
    };
  },
  mounted() {
    axios
      .get(
        `${window.ZUBLU_VARIABLES.ODYSSEY_API}/api/v1/supplier_info?supplier_id=${this.supplierId}`
      )
      .then((response) => {
        this.odysseySupplier = response.data;
      });

    axios
      .get(
        `/actions/zuBlu/public/getSupplierThumbnail?supplierId=${this.supplierId}`
      )
      .then((response) => {
        this.craftSupplier = response.data.supplier;
      })
      .catch((error) => {
        console.error(error);
      });
  },
};
</script>
